// import Lottie from 'lottie-react'
import React, { useEffect, useContext } from 'react'
// import intro from '@/assets/lottie/intro.json'
import { context } from '../../../Layout'
import { AnimatePresence, motion } from 'framer-motion'
import SvgAnimation from './SvgAnimation'

export default function SiteIntro() {
  const { setIntroComplete, introShown } = useContext(context)
  useEffect(() => {
    setTimeout(() => {
      setIntroComplete()
    }, 3000)
  }, [])

  return (
    <AnimatePresence>
      {!introShown && (
        <motion.div
          key="intro"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
          className="w-screen h-screen transition-opacity max-h-screen overflow-hidden max-w-full absolute top-0 left-0 bg-gradient-to-r from-primary to-[#0C1E38] z-[60] flex items-center justify-center"
        >
          <motion.div
            key="intro"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
          >
            {' '}
            <SvgAnimation />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
